(function (t) {
// ky
t.add("label_previous", "\u041c\u0443\u0440\u0443\u043d\u043a\u0443", "KnpPaginatorBundle", "ky");
t.add("label_next", "\u041a\u0438\u0439\u0438\u043d\u043a\u0438", "KnpPaginatorBundle", "ky");
})(Translator);
